import { lazy, Suspense } from "react";
import { AuthSkeleton } from "../../customs/skeleton/main";
const Main = lazy(() => import("../../components/AuthenticationPages/signIn"));

const SignIn = () => {
  return (
      <Suspense fallback={<AuthSkeleton />}>
        <Main />
      </Suspense>
  );
};

export default SignIn;
